/* global mParticle */

/**
 * Helper function to get the mParticle ID.
 * @returns {string} The mParticle ID.
 */
export function getMParticleId() {
  return (typeof mParticle !== 'undefined' && mParticle?.Identity?.getCurrentUser?.()?.getMPID?.()) || '';
}
